import React from "react";
import { timeAgo } from "../utilities/timeAgo";

interface NotificationItemProps {
  n: any;
  onClick: () => void;
  showDot?: boolean;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({
  n,
  onClick,
  showDot = true,
}) => {
  const imageUrl = n.image?.startsWith("http")
    ? n.image
    : `${process.env.REACT_APP_IMAGE_BASE_URL}/${n.image}`;

  return (
    <div
      onClick={onClick}
      className="px-4 py-2  cursor-pointer hover:bg-black/5 relative"
    >
      {n.image ? (
        <div className="flex items-start gap-2">
          <img
            src={imageUrl}
            alt={n.title}
            className="w-10 h-10 rounded-full object-cover"
          />
          <div>
            <h4 className="text-sm font-medium">{n.title}</h4>
            <p className="text-sm text-[#212121]">{n.message}</p>
            <p className="mt-1 text-xs text-gray-500">
              {timeAgo(n.created_at)}
            </p>
          </div>
        </div>
      ) : (
        <>
          <h4 className="text-sm font-medium">{n.title}</h4>
          <p className="text-sm text-[#212121]">{n.message}</p>
          <p className="mt-1 text-xs text-gray-500">{timeAgo(n.created_at)}</p>
        </>
      )}
      {showDot && !n.adminSeen && (
        <div className="absolute w-2 h-2 bg-red-500 rounded-full right-4 top-6" />
      )}
    </div>
  );
};
